import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "about-our-how-to-guides"
    }}>{`About our How-to guides`}</h1>
    <p>{`The following guides contain a set of common use cases and accompanying code snippets that will help you quickly implement a wide variety of features in your add-ons.`}</p>
    <InlineAlert slots="header, text1" variant="info" mdxType="InlineAlert" />
    <p>{`Code Playground integration is coming soon!`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "../../getting_started/code_playground.md"
      }}>{`Code Playground`}</a>{` is the perfect tool to test each how-to snippet. We're currently working on a leaner integration between the Playground and our documentation; running the code will be even easier soon!`}</p>
    <p>{`We're constantly adding new how-tos, so make sure to check back often. If you're looking for Tutorials that guide you in building add-ons from the ground up, please check the `}<a parentName="p" {...{
        "href": "#complete-projects"
      }}>{`Complete Projects`}</a>{` section.`}</p>
    <h2 {...{
      "id": "how-to-guides"
    }}>{`How-to guides`}</h2>
    {/* - Authentication & Authorization
      - [Use OAuth 2.0](./oauth2.md)
     - Data & Environment
      - [Store Data](./local_data_management.md)
      - [Theme & Locale](./theme_locale.md)
     - UI & Interaction
      - [Use Drag & Drop](./drag_and_drop.md)
      - [Use Modal Dialogs](./modal_dialogs.md)
     - Use Design Elements
      - [Use Text](./use_text.md)
      - [Use Geometry](./use_geometry.md)
      - [Use Color](./use_color.md)
      - [Use Images](./use_images.md)
      - [Use Videos](./use_videos.md)
      - [Use Audio](./use_audio.md)
      - [Use PDF and PowerPoint](./use_pdf_powerpoint.md)
      - [Group Elements](./group_elements.md)
      - [Position Elements](./position_elements.md)
     - Use Metadata
      - [Document Metadata](./document_metadata.md)
      - [Page Metadata](./page_metadata.md)
      - [Element Metadata](./element_metadata.md)
     - Exporting & Output
      - [Create Renditions](./create_renditions.md)
      - [Manage with Premium Content](./premium_content.md)
     - User Info
      - [Identify users](./user_info.md) */}
    <br /><br />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Topics`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How-to guides`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Authentication & Authorization`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./oauth2.md"
            }}>{`Use OAuth 2.0`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Data & Environment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./local_data_management.md"
            }}>{`Store Data`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./theme_locale.md"
            }}>{`Theme & Locale`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`UI & Interaction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./drag_and_drop.md"
            }}>{`Use Drag & Drop`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./modal_dialogs.md"
            }}>{`Use Modal Dialogs`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Use Design Elements`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./use_text.md"
            }}>{`Use Text`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./use_geometry.md"
            }}>{`Use Geometry`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./use_color.md"
            }}>{`Use Color`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./use_images.md"
            }}>{`Use Images`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./use_videos.md"
            }}>{`Use Videos`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./use_audio.md"
            }}>{`Use Audio`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./use_pdf_powerpoint.md"
            }}>{`Use PDF and PowerPoint`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./group_elements.md"
            }}>{`Group Elements`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./position_elements.md"
            }}>{`Position Elements`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Use Metadata`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./document_metadata.md"
            }}>{`Document Metadata`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./page_metadata.md"
            }}>{`Page Metadata`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./element_metadata.md"
            }}>{`Element Metadata`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Exporting & Output`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./create_renditions.md"
            }}>{`Create Renditions`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./premium_content.md"
            }}>{`Manage with Premium Content`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`User Info`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./user_info.md"
            }}>{`Identify users`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "complete-projects"
    }}>{`Complete Projects`}</h2>
    <p>{`We've created a set of in-depth tutorials that guide you through the process of building a complete add-on from scratch.`}</p>
    <br /><br />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Topics`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Tutorials`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Document APIs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./tutorials/grids-addon.md"
            }}>{`Design Grid creator`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Communication APIs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./tutorials/stats-addon.md"
            }}>{`Stats Add-on`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Adobe Spectrum Web Components`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./tutorials/spectrum-workshop/index.md"
            }}>{`Basic JavaScript add-on with Spectrum Web Components`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Lit & TypeScript`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./tutorials/using-lit-typescript.md"
            }}>{`Using Lit & TypeScript`}</a></td>
        </tr>
      </tbody>
    </table>
    <p>{`We recommend you to start with the `}<a parentName="p" {...{
        "href": "./tutorials/grids-addon.md"
      }}>{`Design Grid creator`}</a>{`, which covers the basics of the add-on SDK and how to use the Document API.`}</p>
    <p><a parentName="p" {...{
        "href": "./tutorials/grids-addon.md"
      }}><img parentName="a" {...{
          "src": "/express/add-ons/docs/assets/172274af14d924833da630e850b1d314/grids-addon-animation.gif",
          "alt": "Design Grid creator"
        }}></img></a></p>
    <h2 {...{
      "id": "other-resources"
    }}>{`Other resources`}</h2>
    <p>{`We've also created a collection of `}<a parentName="p" {...{
        "href": "../samples.md"
      }}>{`Code Samples`}</a>{` that you can use to get started. You can use the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/references/addonsdk/"
      }}>{`SDK References`}</a>{` to find all of the objects, methods, properties and events supported for building add-ons.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      